import { useQuery } from 'react-query'
import axios from 'axios'
import get from 'lodash/get'
import { getVehicleStatus } from 'utils/vehicles'
import usePageProps from './usePageProps'

const DYNAMIC_FIELDS = `price,discount,state,status,sellerName,isPromotion,estimatedMonthlyPayment,classWarranty,
videoUrl,consignacion,branch,easyAvailableConfirmedAt,ownersNumber,
hasFactoryWarranty,hasDuplicateKeys,hasServiceManual,
acceptFinancing,inspectionOkay,description,
invoiceStatus,clikAutoNumeroFacturasTotales,
clikAutoTotalMultas,clikAutoEstadoUltimaPlaca,clikAutoFacturaOriginal`

const useDynamicVehicleData = () => {
  const { vehicle } = usePageProps()
  const dynamicQuery = useQuery(
    ['vehicleDynamicData', vehicle?.id],
    () => axios.get(`${process.env.NEXT_PUBLIC_API_ROOT}/inventory/${vehicle.id}?fields=${DYNAMIC_FIELDS}`, {
      headers: {
        Accept: '*/*',
      },
    }),
    {
      staleTime: 1000 * 60 * 24,
    },
  )
  const discounts = get(dynamicQuery?.data?.data, 'discount', {})
  const onlineDiscount = discounts
  const titleDiscount = get(onlineDiscount, 'title', '')
  const amountDiscount = get(onlineDiscount, 'amount', 0)
  const operation = get(onlineDiscount, 'operation', 'none')
  const category = get(onlineDiscount, 'category', '')
  const categoryString = category === '' ? 'Descuento' : category
  const hasDiscount = parseInt(amountDiscount) > 0 && operation !== 'suma'
  const endPromotionDate = get(onlineDiscount, 'end_date', null)
  let price = get(dynamicQuery.data?.data, 'price', 0)
  let precioTachado = 0
  if (hasDiscount) {
    if (operation === 'resta') {
      price = Number(price) - Number(amountDiscount)
      precioTachado = Number(vehicle?.price)
    } else if (operation === 'adjusment') {
      precioTachado = Number(vehicle?.price) + Number(amountDiscount)
    }
  }

  const finalPrice = hasDiscount ? Number(price) - amountDiscount : Number(vehicle.price)

  return {
    ...dynamicQuery.data?.data,
    status: getVehicleStatus(vehicle),
    data: dynamicQuery.data,
    onlineDiscount,
    titleDiscount,
    amountDiscount,
    operation,
    category: categoryString,
    hasDiscount,
    discountPrice: price,
    finalPrice,
    endPromotionDate,
    precioTachado,
    price,
    loading: dynamicQuery?.isLoading,
  }
}

export default useDynamicVehicleData
